import styled, { css } from 'styled-components';
export const Button = styled.button `
  aspect-ratio: 1;
  background: var(--bg-secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  &:hover:not(:disabled) {
    background: var(--bg-secondary-hover);
  }

  &:active {
    background: var(--bg-secondary);
  }
`;
export const Container = styled.nav `
  display: flex;
  gap: var(--space-300);

  ${Button} {
    ${({ $size }) => $size === 'small' &&
    css `
        width: 30px;
      `}

    ${({ $size }) => $size === 'medium' &&
    css `
        width: 40px;
      `}
  }
`;
